import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Home from "../views/Home.vue";
import Login from "../views/Login.vue";

Vue.use(VueRouter);

export enum Routes {
  StartPage = "/",
  Login = "/login",
}

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Hem",
    component: Home,
  },
  {
    path: "/login",
    name: "Logga in",
    component: Login,
  },
  {
    path: "/protokoll/:id",
    name: "Reports",
    component: () => import(/* webpackChunkName: "reports" */ "../views/Reports.vue"),
  },
  {
    path: "/nyheter/:id",
    name: "Article",
    component: () => import(/* webpackChunkName: "article" */ "../views/Article.vue"),
  },
];

const router = new VueRouter({
  routes,
});

export default router;
